import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
export function _class_call_check(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}
export { _class_call_check as _ };
